import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const NoSessionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
`;

export const Title = styled.h1`
  ${typographyV2.titleLg};
  text-align: center;
`;

export const Description = styled.p`
  margin-top: 12px;
  margin-bottom: 24px;
  ${typographyV2.bodyBase}
  color: var(--text-soft);
`;
